import { configureStore } from '@reduxjs/toolkit';
import mrbgSliceReducer from './mrbgSlice';

export const mrbgStore = configureStore({
	reducer: mrbgSliceReducer,
});
